<button (click)="speak()" [disabled]="isLoading" color="accent" mat-mini-fab>
  <mat-icon fontSet="material-symbols-outlined">volume_up</mat-icon>
</button>
